import React from "react";
import Modal from "../../Modal";
import { useDispatch } from "react-redux";
import {
  getWinnerList,
  removeWinnerList,
} from "../../../features/slices/challanges";
import { toastService } from "../../../utils/toastify";
import { useLocation } from "react-router-dom";

const DeleteModal = ({ setUpdateState, deleteModalData }) => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteModal: false,
    }));
  };
  const handleDelete = () => {
    const data = {
      userId: deleteModalData?.userId,
    };
    dispatch(removeWinnerList(data)).then((data) => {
      if (data?.payload?.code == 200) {
        toastService.success("Remove winner successfully");
        dispatch(getWinnerList({ challengeId: state }));
        hanldeClose();
      } else {
        toastService.error("Remove winner failed");
      }
    });
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Decline">
          <a className="CloseModal" onClick={hanldeClose}>
            ×
          </a>
          <h3>Delete</h3>
          <p>Are you sure you want to delete this Challenge &amp; Bounty ?</p>
          <h4>
            <a onClick={hanldeClose}>no</a>
            <a onClick={handleDelete}>Yes</a>
          </h4>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
